import React, { useCallback, useMemo } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import DashletErrorRaw from 'pages/Dashboard/components/DashletError';
import { DashletCard } from 'components/DashboardGrid/styles';
import { PluginBlock } from 'ts-components/Plugins/PluginBlock';
import { useDashletMenu } from 'pages/Dashboard/components/Dashlet/DashletMenuContext';
import { buildBlockArgs } from './blockArgs';

const DashletError = DashletErrorRaw as React.ComponentType<{
  dashlet?: any;
  canEdit?: boolean;
  center?: boolean;
  override?: string;
}>;

export const BlockDashletWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const PluginBlockDashlet = ({
  dashlet,
  dateFilter,
  teamFilter,
  model,
}: {
  dashlet: any;
  dateFilter?: any;
  teamFilter?: any;
  model?: { id?: string };
  [key: string]: any;
}) => {
  const { t } = useTranslation();
  const { setCanModifyDashlet } = useDashletMenu();

  const handleIsUninstalledChange = useCallback(
    (isUninstalled: boolean) => {
      setCanModifyDashlet(!isUninstalled);
    },
    [setCanModifyDashlet]
  );

  // Support dashboard-level filters only
  const objectId = model?.id;
  const args = useMemo(
    () => buildBlockArgs({ dateFilter, teamFilter, objectId }),
    [dateFilter, teamFilter, objectId]
  );

  return (
    <BlockDashletWrapper>
      <PluginBlock
        pluginApiName={dashlet?.config?.pluginApiName}
        blockApiName={dashlet?.config?.blockApiName}
        instanceId={dashlet?.id}
        args={args}
        onIsUninstalledChange={handleIsUninstalledChange}
        uninstalledContent={
          <DashletCard style={{ height: '100%', width: '100%' }}>
            <DashletError
              dashlet={dashlet}
              canEdit={false}
              center
              override={t(
                'This block is no longer available. The app that created it may not be enabled.'
              )}
            />
          </DashletCard>
        }
      />
    </BlockDashletWrapper>
  );
};
